import { AloftPrice, ManualAdjustments } from '@aloft/toolkit-shared';

// This is exported so that CompCard can use it directly
// with form values that are not yet in Redux.
export const calculateMarketAdjustment = ({
  manualAdjustments,
  dateOfSaleOrListToSaleAdjustment,
}: {
  manualAdjustments: ManualAdjustments;
  dateOfSaleOrListToSaleAdjustment: AloftPrice;
}) => {
  const concessions = AloftPrice.schema.parse(manualAdjustments.concessions ?? AloftPrice.zero);
  const termsOfSale = AloftPrice.schema.parse(manualAdjustments.termsOfSale ?? AloftPrice.zero);

  return AloftPrice.add(concessions, termsOfSale, dateOfSaleOrListToSaleAdjustment);
};
